import { chain } from 'lodash';
import { SectionType } from '../../../types';
import * as defaults from '../../defaults';
import { injectMissingPropsIntoHtml } from '../../inject-missing-props-into-html';
export const getAllTextRegions = (composerData, sections, experiments) => [
    ...getHtmlFromTextRegions(composerData, experiments),
    ...getHtmlFromTextSubRegionsInMix(composerData, sections, experiments),
];
function getHtmlFromTextRegions({ regions, styles }, experiments) {
    return regions
        .filter(({ type }) => type === SectionType.text)
        .map(({ data, fixed }) => {
        const cssClass = fixed ? 'so-global-title' : 'so-global-p1';
        const textStyle = styles.css?.[cssClass] || {};
        const props = {
            lineHeight: textStyle.originalLineHeight || defaults.defaultLineHeight,
            fontSize: textStyle.fontSize || defaults.defaultTextSize,
        };
        const html = `<div class=${cssClass}>${data.html}</div>`;
        return injectMissingPropsIntoHtml(html, props, { styles }, styles.css, experiments);
    });
}
function getHtmlFromTextSubRegionsInMix({ styles }, sections, experiments) {
    return chain(sections)
        .filter(({ type }) => type === SectionType.mix)
        .map((section) => section.regions)
        .flatten()
        .filter(({ type }) => type === SectionType.text)
        .map(({ html }) => {
        const cssClass = 'so-global-p1';
        const textStyle = styles.css?.[cssClass] || {};
        const props = {
            lineHeight: textStyle.originalLineHeight || defaults.defaultLineHeight,
            fontSize: textStyle.fontSize || defaults.defaultTextSize,
        };
        return injectMissingPropsIntoHtml(`<div class=${cssClass}>${html}</div>`, props, { styles }, styles.css, experiments);
    })
        .value();
}
//# sourceMappingURL=get-all-text-regions.js.map